/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

/**
 * @description Type de courrier :\n- MANDATE : Mandat\n- AGREEMENT : Compromis\n- DEED : Acte\n- DIAGNOSTIC : Diagnostic\n- INVENTORY : Etat des lieux\n- OTHER : Autre\n
 */
export const courrierTypeSchema = z.enum(["MANDATE", "AGREEMENT", "DEED", "DIAGNOSTIC", "INVENTORY", "OTHER"]).default("OTHER").describe("Type de courrier :\n- MANDATE : Mandat\n- AGREEMENT : Compromis\n- DEED : Acte\n- DIAGNOSTIC : Diagnostic\n- INVENTORY : Etat des lieux\n- OTHER : Autre\n")